var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-office-pdf',{attrs:{"src":_vm.pdf},on:{"rendered":_vm.rendered}})
}
var staticRenderFns = []

export { render, staticRenderFns }